export default {
  dp: {
    survey: {
      membershipRemoval: {
        title: 'Before you go...',
        close: 'Close survey',
      },
      designerTagRemoval: {
        title: 'Before you go...',
        close: 'Close survey',
      },
    },
    footer: {
      copyright: 'DocuPet Corp. All rights reserved.',
      tos: 'Terms of Service',
      tosAriaLabel: '@:dp.footer.tos - Footer navigation',
      privacy: 'Privacy Policy',
      privacyAriaLabel: '@:dp.footer.privacy - Footer navigation',
      cookieSettings: 'Cookie Settings',
    },
    navbar: {
      toggle: {
        close: 'Close',
        default: 'Menu',
      },
      tagStore: 'Tag Store',
      shop: 'Shop',
      tagGallery: 'Tag Gallery',
      safeAndHappyFund: 'Safe&Happy Fund',
      licensing: 'Licensing',
      homeSafe: 'Home<em>Safe</em><sup>&reg;</sup>',
      store: 'Store',
      about: 'About',
      licensingInfo: 'About New Licenses',
      faq: 'FAQ',
      aboutRenewing: 'About Renewing Licenses',
      signup: 'Sign Up',
      login: 'Log In',
      dashboard: 'My Dashboard',
      myDetails: 'My Details',
      myAccount: 'My Account',
      logOut: 'Log Out',
      yourAccount: 'Account',
      myPets: 'My Pets',
      profileSettings: 'Profile Settings',
      billingDetails: 'Payment and Subscription',
      orderHistory: 'Order History',
      helpDesk: 'Help Center',
      logoDescription: 'DocuPet - A Safe and Happy Home for every pet',
      skipToMainContent: 'Skip to main content',
      basket: {
        ariaLabel: 'Shopping Basket ({basketCount} items)',
      },
      petGuardians: 'Pet Guardians',
      shopDropdown: {
        shopAll: 'Shop All',
        tags: 'Tags',
        smartTracker: 'Smart Tracker',
        walletCards: 'Wallet Cards',
        collars: 'ID Collars',
      },
      language: 'Language',
      locales: {
        en_CA: 'English [CA]',
        en_US: 'English [US]',
        es_US: 'Español [US]',
        fr_CA: 'Français [CA]',
      },
      backToMenu: 'Back to Menu',
      title: 'Menu',
      label: 'Toggle open or close menu visibility',
    },
    addAddress: {
      manualAddressHeader: 'Add Address',
      button: 'Add Address',
    },
    errorMessages: {
      poBoxOnly:
        'We require a physical address for your profile in the event that your pet becomes lost and needs to be returned to you. You may add an additional mailing address by unchecking the box below.',
      invalidCharacters: 'The {field} has invalid characters',
    },
    input: {
      firstName: {
        label: 'First Name',
        placeholder: 'Enter first name',
        customErrorMessage: {
          isEmpty: 'Your first name is required',
        },
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Enter last name',
        customErrorMessage: {
          isEmpty: 'Your last name is required',
        },
      },
      email: {
        label: 'Email address',
        placeholder: 'Enter email address',
        customErrorMessage: {
          isEmpty: 'Please enter your email address',
          hasValue: 'Please enter a valid email address in the format name@example.com',
        },
        asyncErrorMessage: {
          emailAlreadyExists: `<strong>This email address already exists in our system.</strong><br/>If this is your account, please click <a class="text-decoration-underline" href="{loginLink}">here</a> to log in. Otherwise, please double check you're entering the correct email address.`,
          accountAlreadyExists: `<strong>This email address already exists in our system.</strong><br/>If you have previously registered a pet, we likely have your record on file. Visit the <a class="text-decoration-underline" href="{loginLink}">Fetch my record</a> page to continue.`,
        },
      },
      password: {
        label: 'Create password',
        placeholder: 'Create password',
        customErrorMessage: {
          isEmpty: 'Please enter a password',
          hasValue: 'Your password does not meet the requirements listed below',
          mismatch: 'Password confirmation does not match',
        },
        show: 'Hide Password',
        hide: 'Show Password',
      },
      agreeToTermsConditions: {
        label: 'I agree',
        customErrorMessage: 'Please read and agree to the Terms of Service to proceed',
      },
      agreeToMovingJurisdiction: {
        customErrorMessage: 'Please select this field to continue with moving the pet owner to a new jurisdiction',
      },
      addressSearch: {
        label: 'Search for your {selectedType}',
        placeholder: 'Start typing to search for {selectedType}',
        placeholderAddress: 'address',
        customErrorMessage: 'Please provide your address',
      },
      unit: {
        label: 'Unit / Apt / Suite',
        placeholder: '',
        customErrorMessage:
          'The unit / apt / suite field may only contain alpha-numeric characters, spaces and periods (e.g. Ste. 4, Apt. B).',
      },
      civic: {
        label: 'Number',
        placeholder: '',
        customErrorMessage: 'Please enter your address number',
      },
      street: {
        label: 'Street',
        placeholder: 'Enter street name',
        customErrorMessage: 'Please enter your street name',
      },
      additional: {
        label: '',
        placeholder: 'Additional / PO Box',
      },
      city: {
        label: 'City',
        placeholder: 'Enter city name',
        customErrorMessage: 'Please enter your city name',
      },
      state: {
        label: 'State',
        placeholder: '',
        customErrorMessage: 'Please select your state',
      },
      province: {
        label: 'Province',
        placeholder: '',
        customErrorMessage: 'Please select your province',
      },
      postalCode: {
        label: 'Postal Code',
        placeholder: 'Enter postal code',
        customErrorMessage: {
          required: 'Please enter your postal code',
          invalid: 'Please enter a Postal Code with 6 letters and numbers',
        },
      },
      zipCode: {
        label: 'Zip Code',
        placeholder: 'Enter zip code',
        customErrorMessage: {
          required: 'Please enter your ZIP code',
          invalid: 'Please enter a ZIP Code with 5 numbers.',
        },
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Enter {phoneNumberType} phone number',
        mobilePhone: 'Mobile',
        homePhone: 'Home',
        workPhone: 'Work',
        customErrorMessage: {
          hasValue: 'Please enter your ten digit phone number',
          isEmpty: 'Please enter your phone number',
        },
      },
      birthday: {
        customErrorMessage: {
          month: {
            isEmpty: 'Please select a month',
          },
          day: {
            hasValue: 'Please enter a number between 1 and 31',
            isEmpty: 'Please enter a day',
          },
          year: {
            hasValue: 'Please enter 4 numbers for the year',
            isEmpty: 'Please enter a year',
          },
        },
      },
      dates: {
        monthOptions: {
          default: 'Select',
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'May',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sept: 'Sept',
          oct: 'Oct',
          nov: 'Nov',
          dec: 'Dec',
        },
        errors: {
          birthdateMustBeInPast: 'Birthdates must be in the past',
          mustBeEighteen: 'You must be 18 years or older to purchase a license',
          mustBeEighteenOptional:
            'Providing your date of birth is optional. However, you must be 18 years of age or greater to be issued a license',
          rabiesVaccineExpirMustBeFuture: 'Rabies vaccination expiration dates must be in the future',
          twentyYears: "The rabies vaccination expiration date can't be more than 20 years in the future",
          between: 'Please enter a number between {minNum} and {maxNum}',
          minNumeric: 'Please enter at least {numLimit} numbers',
          maxNumeric: 'Please limit your input to {numLimit} numbers',
          min: 'Please enter at least {numLimit} characters',
          max: 'Please limit your input to {numLimit} characters',
        },
      },
      breed: {
        customErrorMessage: {
          breedAllowedChars: 'Pet breeds can only contain letters, spaces, (round brackets), “-” and “+”',
          required: "Please enter the pet's breed",
        },
      },
      breedKnown: {
        customErrorMessage: {
          required: 'Please make a selection above',
        },
      },
      monthFormat: {
        label: 'Select a month',
      },
      dayFormat: {
        label: 'Enter a day in format dd',
      },
      yearFormat: {
        label: 'Enter a year in format yyyy',
      },
    },
    petPanel: {
      aboutYourPet: 'Tell us about your pet',
      dontHaveAPet: "Don't have a pet?",
      skipThisStep: 'Skip this step',
      whatKindOfPet: 'What kind of pet do you have?',
      chooseOne: 'Choose one',
      petsName: "What is your pet's name?",
      petNameEditWarning:
        "Update your pet's name if the spelling is incorrect or if you are changing the name of your pet. Don't use this record for another pet as all of your pet's information needs to match the details that are on official documents that may need to be provided for licensing.",
      knowBreed: 'Do you know your pet’s breed?',
      whatBreed: 'What breed are they?',
      breedInfoPanel:
        "Start typing your pet's breed. Then select from the options displayed. Please choose the option that most closely matches your pet's breed. Selecting a breed helps others identify your pet if they are reported lost.",
      whatGender: 'What sex are they?',
      knowBirthDate: 'Do you know their date of birth?',
      approximateAge: 'Approximate Age',
      whatColor: 'What color are they? Select all that apply.',
      selectAll: 'Select all that apply',
      indoorCat: 'Indoor Cat',
      outdoorCat: 'Outdoor Cat',
      petCatOptionsRequired: 'Please let us know if {catName} is an indoor cat or an outdoor cat.',
      petSpeciesRequired: "Please select your pet's species",
      petNameRequired: "Please enter your pet's name",
      breedEditLink: 'edit',
      petSexRequired: "Please select your pet's sex",
      petAgeRequired: "Please provide your pet's age",
      petApproximateBirthdateRequired: "Please approximate your pet's age",
      petColorRequired: 'Please pick at least one color',
      petWithNameExists: 'A pet with that name already exists',
      namePlaceholder: 'Enter a name',
      breedPlaceholder: 'Enter breed',
      noMorePets: 'No more pets to add?',
      birthdate: 'Birthdate',
      type: 'Type:',
      breed: 'Breed:',
      sex: 'Sex:',
      spayedNeutered: 'Spay/Neutered',
      microchipNumber: 'Microchip Number',
      tattoo: 'Tattoo #',
      identifyingMarkings: 'Identifying Markings',
      coat: 'Coat',
      petBiography: 'Pet Biography',
      additionalNotes: 'Additional Notes',
    },
    ageOptions: {
      underSixMonths: 'Under 6 months',
      sixMonthsToOneYear: '6 months - 1 year',
      oneYear: '1 year',
      timesYears: '{yearNumber} years',
      seventeenPlusYears: '17+ years',
    },
    colors: {
      white: 'White',
      lightGrey: 'Light-grey',
      darkGrey: 'Dark-grey',
      black: 'Black',
      orange: 'Orange',
      red: 'Red',
      cream: 'Cream',
      apricot: 'Apricot',
      golden: 'Golden',
      tan: 'Tan',
      brown: 'Brown',
      darkBrown: 'Dark-brown',
      lightSilver: 'Light-silver',
      silver: 'Silver',
      lilac: 'Lilac',
      blue: 'Blue',
      darkBlue: 'Dark-blue',
      yellow: 'Yellow',
      rust: 'Rust',
      lightBrown: 'Light-brown',
      grey: 'Grey',
      lightBlue: 'Light Blue',
      pink: 'Pink',
      green: 'Green',
      darkBlueColor: 'Dark Blue',
      color: 'Color',
      beige: 'Beige',
      blonde: 'Blonde',
      fawn: 'Fawn',
      liver: 'Liver',
      chocolate: 'Chocolate',
    },
    generic: {
      optional: 'Optional',
      yes: 'Yes',
      no: 'No',
      male: 'Male',
      female: 'Female',
      dog: 'Dog',
      cat: 'Cat',
      continue: 'Continue',
      size: 'Size',
      remove: 'remove',
      go: 'GO',
      spay: 'spay',
      neuter: 'neuter',
      his: 'his',
      her: 'her',
      she: 'she',
      he: 'he',
      spouse: 'Spouse',
      friend: 'Friend',
      neighbour: 'Neighbor',
      guardian: 'Guardian',
      sitter: 'Sitter',
      singular: 'has',
      plural: 'have',
      petSmallLetter: 'pet',
      pet: 'Pet',
      dogSmallLetter: 'dog',
      priceReducedTo: 'Price reduced to',
      remaining: "remaining",
      position: "Position",
      save: 'Save',
      description: 'Description',
      quantity: 'Quantity',
      almostDone: 'Almost done!',
      previous: 'Previous',
      next: 'Next',
      subscription: 'Subscription',
      tag: 'Tag',
      showAll: "Show All",
      showLess: "Show Less",
      step: "Step",
      length: 'Length',
      width: 'Width',
      free: 'FREE',
      mobile: 'Mobile',
      home: 'Home',
      work: 'Work',
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      sex: 'Sex',
      valid: 'Valid',
      expired: 'Expired',
      spayed: 'Spayed',
      neutered: 'Neutered',
      payments: 'Payments',
      statuses: 'Statuses',
      reOrder: 'Reorder',
      skip: 'Skip',
      refresh: 'Refresh',
    },
    stripeForm: {
      cvcHeader: 'CVV/CVC Code Location Guide',
      cvcHelper:
        'The CVV/CVC code (Card Verification Value/Code) is located on the back of your credit/debit card on the right side of the white signature strip. It is always the last 3 digits in case of VISA and MasterCard. Please copy your CVV/CVC code from the back of your card and continue with your payment.',
      cvcHelperImageAlt: 'look for the 3-digit security code on the back of your card and the 4-digit security code on the front.',
      cvcHelpInfo: 'CVC Help Info',
      cardNumber: 'Card Number',
      expiryDate: 'Expiry',
      cvcNumber: 'CVC',
      country: 'Country',
      postalCode: 'ZIP',
      postalCodePlaceholder: '90210',
    },
    jurisdictionChange: {
      pleaseSelectFromDropdown:
        "We couldn't automatically select the licensing jurisdiction for your updated address. Please select a jurisdiction from the list below.",
      deactivateAccount: 'Deactivate Account',
    },
    imageCropper: {
      title: 'Crop Your Photo',
      back: 'Back',
      applyCrop: 'Apply Crop',
      addToCard: 'Add to Card',
      error: 'Something went wrong, please try again',
    },
    petTemperament: {
      counter: 'Select up to {counter} more from the list below',
      selection: '{selected} out of {max} selected! Deselect 1 option to choose another.',
    },
    reviewPet: {
      dvs: {
        rabiesCert: 'Rabies vaccination proof',
        neuterCert: '{fixed} proof',
      }
    },
    uploadDocs: {
      neuterProof: 'Neuter Proof',
      spayProof: 'Spay Proof',
      additionalNeuterInfo: 'Additional neuter information',
      additionalRabiesInfo: 'Additional rabies information',
      noProofAtThisTime: "I don't have the proof at this time",
      haveNewDate: 'Have a new date?',
      uploadNew: 'Upload New',
      requiredProofsFor: 'Required Proofs for {petName}',
      errorloadingPDF: 'Error loading PDF',
      providedOn: 'Provided On:',
      statusOfLatestProof: 'Status of Latest Proof:',
      neuterWarning: '{petName} requires proof of sterilization',
      rabiesWarning: '{petName} requires a valid proof of rabies vaccination',
      rabiesHelperInfo: 'Documents accepted for {jurisdictionName} include:',
      provide: 'Please provide the rabies vaccination proof for {petName}',
      provideSterilization: 'Please provide the {sterilizationType} proof for {petName}',
      futureRabiesWarning: 'Rabies vaccination expiration dates must be in the future.',
      youMayProceed:
        'You may proceed with the purchase of a license, but you will be required to provide this proof within {range} days. Your license will expire if the proof is not provided.',
      goBack: 'Back to Pet License Information',
      removeProof: 'Remove proof',
      proofStatus: {
        A: 'Approved',
        W: 'Document uploaded',
        D: 'Digital proof of record created',
        J: 'Rejected',
      },
      seeRabiesProofRequirements: 'See rabies vaccination proof requirements',
      rabiesPleaseProvide: 'Your pet must have a current rabies vaccination from a licensed veterinarian. Please provide a rabies certificate that includes:',
      rabiesProofRequirements: {
        petName: "Your pet's name",
        vaccinationDate: "Vaccination date",
        expirationDate: "Expiration date",
        veterinarianInfo: "Veterinarian’s information",
      },
      seeNeuterProofRequirements: 'See spay/neuter proof requirements',
      neuterPleaseProvide: 'Please provide proof from a licensed veterinarian that clearly shows:',
      neuterProofRequirements: {
        petName: "Your pet's name",
        spayNeuterStatus: "The spay/neuter status",
        documentCopy: "Photocopies or clear photos of the original document are accepted, as long as all details are readable"
      },
      proofUploadVerification: {
        verifyWarning: 'Please check that the following is accurate, clear and legible:',
        verifyPoName: 'Your name',
        verifyPetName: "Your pet's name",
        verifyBreed: "Your pet's breed",
        verifyGiven: 'The rabies vaccine is listed as the vaccination given',
        verifyDate: 'The rabies vaccination expiration date',
        verifyManu: 'The vaccine manufacturer',
        verifyLot: 'The vaccine lot number',
        verifyGivenDate: 'The date that the vaccine was given',
        verifyVet: "The document is provided by a veterinarian and includes the veterinarian's name, clinic/hospital name, address and phone number",
        verifyRabiesDate: 'The rabies vaccination expiration date',
        verifySterilizationDate: 'The date of the sterilization',
      },
      proofForSterilizationAndRabiesVaccination:
        'If you have a document that shows both proof of sterilization and proof of a rabies vaccination, please upload the same ' +
        'document for each required proof.',
    },
    rabiesProofUploader: {
      label: 'Please provide the rabies vaccination proof for {petName}',
      pronoun: 'When does {pronoun}',
      expire: 'rabies vaccination expire?',
      subLabel: '@:dp.rabiesProofUploader.pronoun @:dp.rabiesProofUploader.expire',
      subLabelNew: '@:dp.rabiesProofUploader.pronoun new @:dp.rabiesProofUploader.expire',
      helpText: 'Please upload a JPG, BMP, PNG, TIF, HEIC, WEBP or PDF file that is smaller than 8MB.',
      notRequired: 'No proof required',
    },
    buttons: {
      remove: 'Remove',
      loading: 'Loading...',
      uploadProof: 'Upload Proof',
      verifiedProof: 'Verified Proof',
      unverifiedProof: 'Unverified Proof',
      verified: 'Verified',
      pending: 'Pending',
      unverified: 'Unverified',
      checkOut: 'Checkout Now',
      checkoutAriaLabel: 'Checkout and continue to payment',
      promoCode: 'Promo Code',
      learnMoreLinkText: 'here',
      back: 'Back',
      closeAriaLabel: 'close button',
      learnMore: 'Learn More',
      seeMore: 'See More',
      removePet: 'Remove Pet',
      save: 'Save',
      saveChanges: 'Save Changes',
      savePet: 'Save Pet Details',
      edit: 'Edit',
      cancel: 'Cancel',
      isEdited: 'edited',
      unknown: 'Unknown',
      continue: 'Continue',
      submitButtonText: 'Add to Basket',
      selectPetText: 'Select Pet Name',
    },
    productNotFound: {
      backToStore: 'Back to Store',
      notFound: 'Ooops... product not found!',
      error: 'Ooops... something went wrong!',
      buttons: {
        viewAll: 'View All Products',
        refresh: 'Click to Refresh',
      },
    },
    requestAccessCode: {
      errorMessages: {
        access_code_used: "Looks like you've already signed up! {action}",
        default: 'There was a problem with your complete sign-up.{br}Please try again.',
        action: {
          access_code_used: 'Click here to Log In',
        },
      },
    },
    imageConversion: {
      errors: {
        default: 'Something went wrong, please try again',
        invalidType: 'Please upload a JPG, BMP, PNG, TIF, HEIC or WEBP file',
        tooLarge: 'Please upload a file smaller than 10MB',
        inconvertible: 'Something went wrong, please try a different image',
      },
    },
    suggestedJurisdictions: {
      title: 'Tell us which community you live in',
      fallbackJurisdictionOptionLabel: 'None of the above',
      learnMore: 'Learn More',
      aboutDocuPet: 'about DocuPet here',
    },
    securePasswordCheckList: {
      isSecure: 'Your password is secure!',
      oneLowerChar: 'One lowercase character (ex. "j", "p", "a")',
      oneUpperChar: 'One uppercase character (ex. "J", "P", "A")',
      oneDigitChar: 'One number (ex. "1", "5", "8")',
      oneSpecialChar: 'One special character (ex. "&", "#", "$")',
      min: '12 characters minimum',
    },
    countryPopover: {
      label: 'Changing the country region may change pricing and availability.',
    },
    rabiesDocumentPreview: {
      label: 'Rabies Vaccination Expiration Date:',
    },
    baseRadioSwitch: {
      ariaLabel: 'Selection',
      option: 'Option:',
    },
    colorBubble: {
      title: 'Select',
    },
    notification: {
      successMessageOne: 'Success notification will automatically dismiss after 5 seconds and is displayed in',
      successMessageTwo: 'HTML Format',
      errorMessage: 'Error notification will not be dismissed until the user manually dismisses it.',
      warningMessage: 'Warning notification that cannot be dismissed.',
    },
    petTrackingDeviceAddToOrder: {
      startNewOrderItemButtonText: 'Add another Smart Tracker',
      continueButtonText: 'View Basket & Checkout',
    },
    common: {
      colour: 'color'
    },
    region: {
      us: 'United States',
      ca: 'Canada'
    },
    error: {
      title: 'Ruh-roh!',
      body: 'Looks like something went wrong! If you keep getting this message, please let us know.',
      error: 'Something went wrong loading the Pet Owner or Order',
      tryAgain: 'Please try refreshing the page.',
      refresh: 'Refresh',
    },
    petOwnerHeader: {
      poId: 'PO ID',
      email: 'Email',
      phone: 'Phone',
      organization: 'Organization',
      jurisdiction: 'Jurisdiction',
      reOrder: 'Reorder of order',
      bin: 'BIN',
      soldBy: 'Sold By',
      vendor: 'Vendor',
      orderStatus: 'Order Status:',
      petOwnerLocalTime: 'Pet Owner Local Time:',
      rePrint: 'Reprint Receipt',
    },
    productSummary: {
      free: 'FREE',
      personalization: 'Personalization',
      tax: 'Tax',
      donation: 'donation',
      voiceAndSight: 'Voice & Sight',
      coupons: 'Coupons',
    },
    directFulfillTag: {
      petId: 'Pet ID',
      validate: 'Validate',
      tagAssigned: 'Tag assigned',
      invalidTagNumber: 'Invalid Tag Number',
      inUseTagNumber: 'Tag Number is already in use',
      inventoryStatusNotUpdated: 'Tag Number inventory status is out of date',
      assignedTagNumber: 'Tag Number is already assigned',
      tagProductMismatch: 'Tag product mismatch',
    },
    petDetails: {
      currentlyEligibleForRenewal: 'Currently Eligible for Renewal',
      editOrRemovePet:'Edit or Remove <span class="sr-only">{name}</span> Pet',
      petDetails: 'Pet Details',
      petLicensingInformation: 'Pet Licensing Information',
      dateOfBirth: 'Date of Birth',
      animalType: 'Animal Type',
      breed: 'Breed',
      currentLicenseExpiration: 'Current License Expiration',
      noLicenseOnRecord: 'No license on record',
      rabiesVaccineExpiry: 'Rabies Vaccine Expiry',
      rabiesStatus: 'Rabies Status',
      notProvided: 'Not provided',
      microchipStatus: 'Microchip Status',
      editInfoWhenAddingToOrder: 'This information can be edited when adding to an order',
      specialDesignations: 'Special Designations',
      canineGoodNeighbour: 'Canine Good Neighbor',
      serviceDog: 'Service Dog',
      dangerousAnimal: 'Dangerous Animal',
      restrictedBreed: 'Restricted Breed',
    },
    required: 'Required',
  },
};
